import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { rowNameButton } from '../../../../components/DataTable'
import { MOBILE } from '../../../../guided-toolbox/utils/breakpoints'

// Explicit column sizes align the separate grids and reserve 110px for balances.
const ROW_COLUMNS = 'minmax(0, 150px) minmax(0, 105px) minmax(60px, 1fr) 110px 30px'
const ROW_AREAS = "'type ticker name balance menu'"

// Truncate long labels so they do not increase the row height.
const truncateOneLine = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const RowList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const GroupList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`

export const RowHeader = styled.div`
  display: grid;
  grid-template-columns: ${ROW_COLUMNS};
  grid-template-areas: ${ROW_AREAS};
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
  padding: 0 10px 0 8px;
  color: ${p => p.theme.lightestGray ?? '#7a8e96'};
  font-size: 14px;
  line-height: 24px;

  /* Increase specificity so each cell uses the header color instead of its own. */
  && > * {
    color: inherit;
  }

  ${MOBILE} {
    display: none;
  }
`

export const Row = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: ${ROW_COLUMNS};
  grid-template-areas: ${ROW_AREAS};
  align-items: center;
  gap: 12px;
  min-height: 48px;
  padding: 0 10px 0 8px;
  background-color: ${p => p.theme.cardHoverBgColor ?? '#f5fafc'};
  border-radius: 10px;
  color: ${p => p.theme.lightestGray ?? '#7a8e96'};
  font-size: 16px;
  line-height: 22px;

  ${MOBILE} {
    grid-template-columns: minmax(0, 1fr) 30px;

    /* Span the menu across all rows so its height does not enlarge the first text row. */
    grid-template-areas:
      'type menu'
      'ticker menu'
      'name menu'
      'balance menu';
    align-items: start;
    gap: 5px 12px;
    padding: 10px;
  }
`

export const Type = styled.div`
  grid-area: type;
  min-width: 0;
  ${truncateOneLine};
`

export const Ticker = styled.div`
  grid-area: ticker;
  min-width: 0;
  ${truncateOneLine};
`

export const Name = styled.div`
  grid-area: name;
  min-width: 0;
  ${truncateOneLine};
`

export const HeaderLabel = styled.span`
  min-width: 0;
  ${truncateOneLine};
`

export const NameLink = styled.button`
  ${rowNameButton};
  display: block;
  max-width: 100%;
  font-size: inherit;
  line-height: inherit;
  ${truncateOneLine};
`

export const Balance = styled.div`
  grid-area: balance;
  color: ${p => p.theme.darkestGray ?? '#022a3a'};
  text-align: right;
  white-space: nowrap;

  ${MOBILE} {
    text-align: left;
  }
`

export const RowMenu = styled.div`
  grid-area: menu;
  display: flex;
  justify-content: flex-end;
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding-bottom: 16px;
  color: ${p => p.theme.mediumGray ?? '#4a606a'};
  font-size: 18px;
  line-height: 24px;

  ${MOBILE} {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding-bottom: 20px;
  }
`

export const SectionBalance = styled.div`
  color: ${p => p.theme.lightestGray ?? '#7a8e96'};
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;
`

export const BalanceCaption = styled.div`
  color: ${p => p.theme.lightestGray ?? '#7a8e96'};
  font-size: 14px;
  line-height: 22px;
`
